module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Thêm mới permissions",
      "breadcrumbs": [{
        title: 'Quản lý permissions',
        route: {
          name: 'permission'
        }
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('el-form', {
    ref: "createPermissionForm",
    attrs: {
      "model": _vm.localPermission,
      "rules": _vm.rules,
      "label-width": "200px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmitRole('createPermissionForm')
      }
    }
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên"
    },
    model: {
      value: (_vm.localPermission.name),
      callback: function($$v) {
        _vm.$set(_vm.localPermission, "name", $$v)
      },
      expression: "localPermission.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên hiển thị"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên hiển thị"
    },
    model: {
      value: (_vm.localPermission.display_name),
      callback: function($$v) {
        _vm.$set(_vm.localPermission, "display_name", $$v)
      },
      expression: "localPermission.display_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Mô tả"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "Mô tả"
    },
    model: {
      value: (_vm.localPermission.description),
      callback: function($$v) {
        _vm.$set(_vm.localPermission, "description", $$v)
      },
      expression: "localPermission.description"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }, [_vm._v("Chọn tất cả")]), _vm._v(" "), _c('el-checkbox-group', {
    staticClass: "margin-top margin-lg-bottom",
    model: {
      value: (_vm.localPermission.prefix),
      callback: function($$v) {
        _vm.$set(_vm.localPermission, "prefix", $$v)
      },
      expression: "localPermission.prefix"
    }
  }, _vm._l((_vm.permissionHelpers.prefixs), function(prefix, key, index) {
    return _c('el-checkbox', {
      key: key,
      attrs: {
        "label": key
      }
    }, [_vm._v(_vm._s(prefix))])
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_vm._v("Thêm mới")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8535785e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/permission/NewPermission.vue
// module id = 652
// module chunks = 1